<template>
  <div class="d-flex" @click.stop>
    <router-link
      :to="link"
      :style="{ flex: $currentUser ? '1 0 calc(50% - 4px)' : '1 0 100%' }"
      class="btn btn-outline-primary py-1 t-600 mr-1"
    ><i class="fa fa-eye mr-1" /> See More</router-link>
    <bookmark-folder
      v-if="$currentUser"
      class="ml-1"
      style="flex: 1 0 calc(50% - 4px);"
      :currentItem="data"
      :scope="index"
      isFromSearch
      attachedToBody
      isButton>
    </bookmark-folder>
  </div>
</template>

<script>
import BookmarkFolder from '@/components/bookmark_folder/Show'

export default {
  name: 'searchResultBaseActions',
  components: {
    BookmarkFolder
  },
  props: {
    index: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    link: {
      type: Object,
      required: true
    }
  }
}
</script>
